// moz667: por culpa de vrdemo
var $ = jQuery;

var $wrap = $("#streaming-send-question-wrap");

// FIXME: hacer que el dialogo de alerta no ponga el backdrop? o alguna otra forma que no moleste tanto

function init() {
    var url_send = $wrap.data("url-send");
    var $btn_send = $wrap.find(".btn");

    $('#streaming_send_question').keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();

            $btn_send.trigger( "click" );
            return false;
        }
    });

    $btn_send.on("click", function () {
        $btn_send.attr("disabled", true);
        $.ajax({
            method: "GET", // FIXME: hacer que sea POST, por ahora es GET ya que si no tenemos que lidiar con el CSRF
            url: $wrap.data("url-send"),
            data: {
                streaming_send_question: $("#streaming_send_question").val()
            }
        }).fail(function() {
            alertDialog.show({
                title: n2m_i18n("Error al enviar la pregunta"),
                message: n2m_i18n("Error al enviar la pregunta. Intenteló mas tarde.")
            });
        }).done(function(data) {
            var message = "";
            var title = "";
            if (data.message) {
                message = data.message;
            } else if (data.error) {
                title = data.title ? data.title : "";
                message = data.error;
            }

            alertDialog.show({
                title: title,
                message: message,
                onHide: function () {
                    if (!data.error) {
                        $("#streaming_send_question").val("");
                    }
                }
            });
        }).always(function () {
            $btn_send.attr("disabled", false);
        });
    });
}

if ($wrap.length > 0) {
    init();
}
